/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Day_Tough_Samuel_ClipInputs */

const fr_day_tough_samuel_clip = /** @type {(inputs: Day_Tough_Samuel_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valider`)
};

/**

* @param {Day_Tough_Samuel_ClipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const day_tough_samuel_clip = /** @type {((inputs?: Day_Tough_Samuel_ClipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Day_Tough_Samuel_ClipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_day_tough_samuel_clip(inputs)
});